import { Component, OnInit } from '@angular/core';

@Component({
  template: require('./usuarios.component.html')
})
export class UsuariosComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}



/** WEBPACK FOOTER **
 ** ./~/angular2-template-loader!./src/app/recursos-humanos/usuarios/usuarios.component.ts
 **/